import * as fetchBookingStats from 'store/actions/bookingStats/fetchBookingStats';
import * as types from 'store/actions/types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

function* fetchBookingStatsAsync({ payload }) {
    try {
        const url = `${ config.getApiBaseUrl() }/statistics/bookings`;

        const response = yield apiClient.read(url, payload);

        yield put(fetchBookingStats.fetchBookingStatsSuccess(response, payload));
    } catch (error) {
        yield put(fetchBookingStats.fetchBookingStatsFailure(error));
    }
}

function* failureMessage({ error }) {
    const { message } = error.response;

    yield put(showNotification(message, 'warning'));
}

export default function* usersSagas() {
    yield [
        takeEvery(types.FETCH_BOOKING_STATS, fetchBookingStatsAsync),
        takeEvery(types.FETCH_BOOKING_STATS_FAILURE, failureMessage),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/bookings/bookingStatsSagas.js